import * as React from 'react';
import styled from "styled-components";
import { MapLegendProps, MapLegendStyleProp } from '../../interface/MapInterface';
import { numberWithDollarSign, numberWithCommas, legendFormat } from "./Helpers";

const LegendContainer = styled.span`
    position: ${props => props.isEmployee ? "" : "absolute"};
    top: ${ (props: MapLegendStyleProp) => props.isCongress ? (props.factSheet ? 450 : 350) : props.isEmployee ? 0 : props.mapHeight - props.legendHight - 5}px;
    left: ${ (props: MapLegendStyleProp) => props.isCongress ? (props.factSheet ? 20 : 780): props.isInState ? props.mapWidth + 20 : props.isEmployee ? 0 : props.mapWidth-30}px`;


class MapLegend extends React.Component<MapLegendProps> {

    getLegendData = () => {

        if (this.props.isEmployee) {
            let legendData = {}, color;
           // let uniqueCounts = [...new Set(this.props.otherStateEmployeeCounts)];
            //console.log(uniqueCounts);
            this.props.otherStateEmployeeCounts.forEach(count => {
                color = this.props.colorScale(count);
                if (!legendData[color]) {
                    legendData[color] = [];
                }
                legendData[color].push(count);
            })
            Object.keys(legendData).forEach(key => {
                const range = legendData[key];
                const rangeText = (range[0] === range[range.length - 1])
                    ? `${numberWithCommas(range[0])}`
                    : `${numberWithCommas(range[range.length - 1])} to ${numberWithCommas(range[0])}`;


                legendData[key] = rangeText;
            })
            //if (this.props.homeStateEmployeeCount.length > 0 && !this.props.agg) {
            //    legendData["#f37335"] = numberWithCommas(this.props.homeStateEmployeeCount);
            //}

            return legendData;
        } else {
            //.reverse() will mutate the array in place, need to copy the array first
            const legendData = [...this.props.colorScheme].reverse().map((color, i) => {
                const range = this.props.colorScale.invertExtent(color);

                //const start_old = range.length > 0 && range[0] ? numberWithDollarSign(range[0].toFixed(0)) : 0;
                const start = range.length > 0 && range[0] ? legendFormat(range[0], i, "start") : 0;
                
                //let end_old = (i < this.props.colorScheme.length - 1)
                  //  ? numberWithDollarSign((range[1] - 1).toFixed(0))
                  //  : range.length > 1 && range[1] && numberWithDollarSign(range[1].toFixed(0));

                let end = (i < this.props.colorScheme.length - 1)
                    ? legendFormat((range[1] - 1), i, "end")
                    : range.length > 1 && range[1] && legendFormat(range[1], i, "end");

                const rangeText = (end !== '$NaN') ? `${start} to ${end}` : `${start}+`;
                return { [color]: rangeText };
            }).reduce((obj, item) => {
                const colorKey = Object.keys(item)[0];
                obj[colorKey] = item[colorKey];
                return obj;
            },
                {});

            if (this.props.isCongress && this.props.isInstate) {
                legendData["#d3d3d3"] = "No Spending found";
            }

            return legendData;
        }
    }
    render() {
        const legendData = this.getLegendData();
        //console.log(this.props)
        const spendingType = this.props.tablename.charAt(0).toUpperCase() + this.props.tablename.slice(1);
        const employeeIndex = 2;
        const fontSize1 = (this.props.isZoomed) ? '17px' : (this.props.factSheet) ? '16px' : '14px';
        const fontSize2 = (this.props.isZoomed) ? '16px' : '11px';
        return (
            <LegendContainer
                factSheet={this.props.factSheet}
                className={this.props.isZoomed && this.props.isCongress ? 'congress_zoomed_legend' : this.props.factSheet ? 'factsheet_legend' : ''}
                isCongress={this.props.isCongress}
                isInState={this.props.isInstate}
                isEmployee={this.props.isEmployee}
                mapWidth={this.props.mapAreaWidth}
                mapHeight={this.props.mapAreaHeight}
                legendHight={this.props.legendBoxHeight + this.props.legendTitleHeight + 2 * this.props.legendPadding}>
                <svg
                    width={this.props.isEmployee ? 220 : this.props.legendAreaWidth}
                    viewBox={this.props.isZoomed ? "0 0 210 200" : null}
                    height={this.props.isEmployee ? 250 : this.props.isZoomed ? 180 : this.props.factSheet ? 180 : this.props.legendBoxHeight + 20 + this.props.legendTitleHeight + 2 * this.props.legendPadding}>
                    <g>
                        {/*<text style={{ fontSize: '18px', "height": "10px" }}>well</text>*/}
                        <text style={{ fontSize: fontSize1, fontWeight: 'bold' }}
                            transform={`translate(${this.props.factSheet ? "20" : "2"},${this.props.isZoomed ? "20" : this.props.factSheet ? "12" : "15"})`}>
                            {this.props.factSheet ? 'Spending Amount' : (this.props.isEmployee) ? 'Employee Count' : `${spendingType === "All" ? "" : spendingType} Expenditures`}
                        </text>
                        <rect style={{ fill: 'none' }} width={this.props.legendBoxWidth} height={(this.props.colorScheme.length + 1) * this.props.legendLineHeight - this.props.legendCellHeight + 2 * this.props.legendBoxPadding} transform={`translate(0,${this.props.legendTitleHeight})`} />
                        {this.props.isEmployee &&

                            <g transform={`translate(5,${this.props.legendLineHeight + this.props.legendBoxPadding})`}>
                                {/*!this.props.agg && !this.props.isInstate &&
                                <rect
                                    style={{ fill: "#f37335", stroke: '#d4d4d4' }}
                                    width={this.props.legendCellWidth}
                                    height={this.props.legendCellHeight}
                                    y={(0 + 1) * this.props.legendLineHeight - this.props.legendCellHeight}
                                />
                                */}
                                {/*!this.props.agg && !this.props.isInstate && <text style={{ fontSize: '12px' }} x={25} y={((0 + 1) * this.props.legendLineHeight) - 5}>University home state ({numberWithCommas(this.props.homeStateEmployeeCount)})</text>*/}
                                {
                                    Object.keys(legendData).map((color, i) => {
                                    return <rect key={color} style={{ fill: color, stroke: '#d4d4d4' }} width={this.props.legendCellWidth} height={
                                            this.props.legendCellHeight} y={(i + employeeIndex + 0) * this.props.legendLineHeight - this.props.legendCellHeight} />
                                    })

                                }
                                {
                                    Object.keys(legendData).map((color, i) => {
                                    return <text style={{ fontSize: '12px' }} key={color} x={25} y={((i + employeeIndex + 0) * this.props.legendLineHeight) - 5}>{legendData[color]}</text>
                                    })

                                }
                                <rect style={{ fill: "#F5FCFF", stroke: '#d4d4d4' }} width={this.props.legendCellWidth} height={
                                    this.props.legendCellHeight} y={(Object.keys(legendData).length + 2) * this.props.legendLineHeight - this.props.legendCellHeight} />
                                <text style={{ fontSize: '12px' }} x={25} y={((Object.keys(legendData).length + 2) * this.props.legendLineHeight) - 5}>{"< 5 (masked for privacy)"}</text>
                                <rect
                                    style={{ fill: "#FFFFFF", stroke: '#d4d4d4' }}
                                    width={this.props.legendCellWidth}
                                    height={this.props.legendCellHeight}
                                    y={(Object.keys(legendData).length + 3) * this.props.legendLineHeight - this.props.legendCellHeight}
                                />
                                <text style={{ fontSize: '12px' }} x={25} y={((Object.keys(legendData).length + 3) * this.props.legendLineHeight) - 5}>{"No employees found"}</text>
                            </g>
                        }
                        {this.props.factSheet && 
                            <g transform={`translate(25,${this.props.legendLineHeight + this.props.legendBoxPadding})`}>
                                {
                                    Object.keys(legendData).map((color, i) => {
                                        return <rect key={color} style={{ fill: color }} width={this.props.legendCellWidth + 12} height={
                                            this.props.legendCellHeight + 15} y={i*20} />
                                    })

                                }
                                {
                                    Object.keys(legendData).map((color, i) => {
                                        return <text style={{ fontSize: '16px' }} key={color} x={40} y={17+ (i*21)}>{legendData[color]}</text>
                                    })

                                }
                            </g>
                        }
                        {!this.props.isEmployee && !this.props.factSheet &&
                            <g transform={`translate(5,${this.props.legendLineHeight + this.props.legendBoxPadding})`}>
                                {
                                    Object.keys(legendData).map((color, i) => {
                                        return <rect key={color} style={{ fill: color }} width={this.props.legendCellWidth} height={
                                            this.props.legendCellHeight} y={(i + 1) * this.props.legendLineHeight - this.props.legendCellHeight} />
                                    })

                                }
                                {
                                Object.keys(legendData).map((color, i) => {
                                    return <text style={{ fontSize: fontSize2 }} key={color} x={25} y={(i + 1) * this.props.legendLineHeight}>{legendData[color]}</text>
                                    })

                                }
                            </g>
                        }
                    </g>          
                </svg>
            </LegendContainer>)
    }
}

export default MapLegend;